import React, { useState } from 'react';
import { FileUploaderWrapper } from './FileUploaderStyled.js'
import AlertModal from "web/components/AlertModal";

const FileUploader = ({ onUploadOrRemove, maxFiles = 5, mandatory, buttonName = 'Upload Documents' }) => {
    const [files, setFiles] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState("");

    const handleUpload = (event) => {
        const newFiles = Array.from(event.target.files);
        const validFiles = newFiles.filter(file => {
            if (file.size > 5 * 1024 * 1024) {
                setModalContent('File should not be larger than 5 MB')
                setModal(true)
                return false;
            }
            return true;
        });
        if (files.length + validFiles.length > maxFiles) {
            return;
        }
        const updatedFiles = [...files, ...validFiles];
        setFiles(updatedFiles);
        if (onUploadOrRemove) onUploadOrRemove(updatedFiles);
    };

    const handleRemove = (index) => {
        const updatedFiles = files.filter((_, i) => i !== index);
        setFiles(updatedFiles);
        if (onUploadOrRemove) onUploadOrRemove(updatedFiles);
    };

    return (
        <FileUploaderWrapper>
            <input
                type="file"
                multiple
                onChange={handleUpload}
                style={{ display: 'none' }}
                id="file-upload-input"
                disabled={files.length >= maxFiles}
            />
            <label htmlFor="file-upload-input" className={`upload-button ${(files.length >= maxFiles) ? 'disabled' : ''}`}>
                {buttonName}<span>{mandatory !== 'no' ? '*' : ''}</span>
            </label>
            <h5 className='max-length-label'>Maximum {maxFiles} files can be uploaded (Should not exceed 5 MB each)</h5>
            <ul className="file-list">
                {files.map((file, index) => (
                    <li key={index} className="file-item">
                        {file.name}
                        <button
                            type="button"
                            className="remove-button"
                            onClick={() => handleRemove(index)}
                        >
                            &times;
                        </button>
                    </li>
                ))}
            </ul>
            <AlertModal
                isOpen={modal}
                toggle={() => setModal(!modal)}
                content={modalContent}
            />
        </FileUploaderWrapper>
    );
};

export default FileUploader;